import { defineMessages } from 'react-intl';

/** The head of Pitch (design navigation-v2 d 4a): one title over the four tabs. */
export const pitchHeadMessages = defineMessages({
  title: { id: 'app.outreach.pitch.title', defaultMessage: 'Pitch' },
  subtitle: {
    id: 'app.outreach.pitch.subtitle',
    defaultMessage: 'Plug finds new curators every day and pitches your song from your mailbox.',
  },
});
